/* eslint-disable no-underscore-dangle */
import { HtmlDocumentType } from '@/types';

const get = (key: string) => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return ((window._env ?? {})[key] ?? process.env[key]) || '';
};

// eslint-disable-next-line no-shadow
export enum SiteId {
  ApiCafe = 'api-cafe',
  BankApi = 'bank-api',
}

const env = {
  siteName: process.env.REACT_APP_SITE_NAME ?? '',
  siteId: process.env.REACT_APP_SITE_ID ?? '',
  domain: process.env.REACT_APP_DOMAIN_NAME ?? '',
  apiCafeDomain: process.env.REACT_APP_APICAFE_DOMAIN_NAME ?? 'apicafe.io',
  bankApiDomain: process.env.REACT_APP_BANKAPI_DOMAIN_NAME ?? 'bank-api.net',
  rootUrl: process.env.REACT_APP_ROOT_URL ?? '',
  supportEmail: 'hello@bank-api.net',
  app: {
    authCodeEnabled: get('REACT_APP_AUTH_CODE_ENABLED'),
    authResourceOwner: get('REACT_APP_AUTH_RESOURCE_OWNER'),
    authCodeAppId: get('REACT_APP_AUTH_CODE_APPID'),
    redirectUrl: get('REACT_APP_REDIRECT_URL'),
    tymeSubDomain: get('REACT_APP_TYME_SUBDOMAIN'),
    tymePostmanLink: get('REACT_APP_TYME_POSTMAN_LINK'),
    swaggerBucketName: get('REACT_APP_SWAGGER_BUCKET_NAME'),
  },
  tinyMce: {
    apiKey: process.env.REACT_APP_TINY_MCE_API_KEY ?? '',
  },
  ga: {
    trackingCode: process.env.REACT_APP_GA_TRACKING_CODE ?? '',
  },
  messages: {
    internalError: 'An unexpected error has occurred. Please contact us at hello@bank-api.net.',
  },
  roles: {
    apiPublisher: 'ApiPublisher',
    bankAdmin: 'BankAdmin',
    directoryAdmin: 'DirectoryAdmin',
    superAdmin: 'SuperAdmin',
    organisationOwner: 'OrganisationOwner',
    organisationUser: 'OrganisationUser',
  },
  api: {
    baseUrl: {
      tokenBaseUrl: get('REACT_APP_TOKEN_BASE_URL_V7'),
      account: process.env.REACT_APP_ACCOUNT_BASE_URL ?? '',
      token: process.env.REACT_APP_TOKEN_BASE_URL ?? '',
      identityService: process.env.REACT_APP_IDENTITY_SERVICE_BASE_URL ?? '',
      apiPortal: process.env.REACT_APP_API_PORTAL_BASE_URL ?? '',
      openBankingVirtualBank:
        process.env.REACT_APP_OPEN_BANKING_VIRTUAL_BANK_SERVICE_BASE_URL ?? '',
      openBankingAuthService: process.env.REACT_APP_OPEN_BANKING_AUTH_SERVICE_BASE_URL ?? '',
      membership: process.env.REACT_APP_MEMBERSHIP_SERVICE_BASE_URL ?? '',
      dataLoader: process.env.REACT_APP_DATA_LOADER_SERVICE_BASE_URL ?? '',
      countryInformation: process.env.REACT_APP_COUNTRY_INFORMATION_BASE_URL ?? '',
      payments: process.env.REACT_APP_PAYMENT_SERVICE_BASE_URL ?? '',
    },
    clientKey: process.env.REACT_APP_CLIENT_ID ?? '',
    clientSecret: process.env.REACT_APP_CLIENT_SECRET ?? '',
    tenantDomain: process.env.REACT_APP_TENANT_DOMAIN ?? '',
  },
  cookie: {
    domain: process.env.REACT_APP_COOKIE_DOMAIN ?? '',
  },
  disqus: {
    shortNameId: 'apicafe-io',
  },
  dev: {
    subdomain: process.env.REACT_APP_DEV_SUBDOMAIN ?? '',
    // subdomain: 'testing-bank-0602133',
  },
  facebookID: process.env.REACT_APP_FACEBOOK_ID ?? '',
  htmls: {
    [HtmlDocumentType.TERMS_OF_USE]: get('REACT_APP_DOCUMENT_TERM_OF_USE'),
    [HtmlDocumentType.ABOUT_US]: get('REACT_APP_DOCUMENT_ABOUT_US'),
    [HtmlDocumentType.PRIVACY_POLICY]: get('REACT_APP_DOCUMENT_PRIVACY_POLICY'),
    [HtmlDocumentType.FAQ]: get('REACT_APP_DOCUMENT_FAQ'),
  },
  videos: {
    accountsAndTransactionApis: 'https://www.youtube.com/embed/NMCoWpZoGp4',
    bankApi: 'https://www.youtube.com/embed/NCyFlX9AFuQ',
    getStarted: 'https://www.youtube.com/embed/X4uhk8t20wE',
  },
  socials: {
    firebaseApiKey: process.env.REACT_APP_FIREBASE_API_KEY ?? '',
    firebaseAuthDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN ?? '',
    googleClientId: process.env.REACT_APP_GOOGLE_CLIENT_ID ?? '',
    googleClientSecret: process.env.REACT_APP_GOOGLE_CLIENT_SECRET ?? '',
    facebookAppID: process.env.REACT_APP_FACEBOOK_APP_ID ?? '',
    linkedinClientId: process.env.REACT_APP_LINKEDIN_CLIENT_ID ?? '',
    linkedinClientSecret: process.env.REACT_APP_LINKEDIN_CLIENT_SECRET ?? '',
    linkedinCallBack: process.env.REACT_APP_LINKEDIN_CALLBACK_URL ?? '',
    oauthBaseUrlLinkedin: 'https://www.linkedin.com/oauth/v2',
  },
  mainServiceDirectory: process.env.REACT_APP_MAIN_SERVICE_DIRECTORY ?? 'apidoc',
  swagger: {
    clientId: process.env.REACT_APP_SWAGGER_CLIENT_ID ?? '',
    clientSecret: process.env.REACT_APP_SWAGGER_CLIENT_SECRET ?? '',
  },
};

export default env;
